// src/components/subscription/SubscriptionRequired.jsx

import React, { useState } from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import SubscriptionPlans from './SubscriptionPlans';

export default function SubscriptionRequired({ requiredPlan = 'basic', reason = 'access', type }) {
  const [showPlans, setShowPlans] = useState(false);
  const { getCurrentPlan, plans } = useSubscription();
  
  const currentPlan = getCurrentPlan();
  const required = plans[requiredPlan.toUpperCase()];

  const getTitle = () => {
    switch (reason) {
      case 'usage_limit':
        return `${type === 'orders' ? 'Sipariş' : type === 'customers' ? 'Müşteri' : type} Limitiniz Doldu`;
      case 'expired':
        return 'Aboneliğiniz Sona Erdi';
      default:
        return 'Abonelik Gerekli';
    }
  };

  const getMessage = () => {
    switch (reason) {
      case 'usage_limit':
        return `Bu özelliği kullanmaya devam etmek için aboneliğinizi yükseltmeniz gerekiyor.`;
      case 'expired':
        return 'Bu özelliklere erişim için aboneliğinizi yenilemeniz gerekiyor.';
      default:
        return `Bu özellik ${required?.name || 'ücretli'} plan ve üzeri ile kullanılabilir.`;
    }
  };

  if (showPlans) {
    return <SubscriptionPlans onClose={() => setShowPlans(false)} />;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      padding: '40px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      margin: '20px'
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#ffd700',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '32px'
        }}>
          👑
        </div>
        
        <h2 style={{
          color: '#333',
          marginBottom: '16px',
          fontSize: '24px'
        }}>
          {getTitle()}
        </h2>
        
        <p style={{
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          {getMessage()}
        </p>

        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '24px',
          textAlign: 'left'
        }}>
          <div style={{ marginBottom: '12px' }}>
            <strong>Mevcut Planınız:</strong> {currentPlan.name} ({currentPlan.price === 0 ? 'Ücretsiz' : `${currentPlan.price}₺/ay`})
          </div>
          {requiredPlan && (
            <div>
              <strong>Gerekli Plan:</strong> {required?.name} ({required?.price}₺/ay)
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => setShowPlans(true)}
            style={{
              backgroundColor: '#06C167',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '16px'
            }}
          >
            Planları Görüntüle
          </button>
          
          <button
            onClick={() => window.history.back()}
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Geri Dön
          </button>
        </div>
      </div>
    </div>
  );
}